/*
  NOTE: This method is likely to change and evolve soon, so we'll
  skip unit testing it for now.
*/



function parseUserLocationType(value = '') {
  // NOTE: Value could be an `id` or `type`

  const types = [
    { id: 1, type: 'Table', description: 'Table' },
    { id: 2, type: 'Room', description: 'Room', icon: 'fa-door-closed' },
    { id: 3, type: 'Pool', description: 'Pool', icon: 'fa-swimmer' },
    { id: 4, type: 'GeneralDining', description: 'Table' },
    { id: 5, type: 'GeneralOutside', description: 'Table' },
    { id: 6, type: 'Cabana', description: 'Cabana' },
    { id: 7, type: 'Box', description: 'Box' },
    { id: 8, type: 'Seat', description: 'Seat', icon: 'fa-chair' },
    { id: 9, type: 'Hole', description: 'Hole', icon: 'fa-golf-ball' },
    { id: 10, type: 'PoolSeat', description: 'Pool Seat', icon: 'fa-chair' },
    { id: 11, type: 'PoolChair', description: 'Pool Chair', icon: 'fa-chair' }
  ];

  const type = types.find((t) => {
    const isTypeMatch = t.type.toLowerCase() === String(value).toLowerCase();
    const isIdMatch = t.id === Number(value);
    return isTypeMatch || isIdMatch;
  });

  return type || types[0];
}



export default parseUserLocationType;
